import { useMutation } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { CallResponse, HttpResponse, UpdateCallRequest } from "@/types";

export function useUpdateCall() {
  return useMutation({
    mutationFn: async ({ callId, updateCallRequest }: { callId: string; updateCallRequest: UpdateCallRequest }) => {
      const path = `calls/${callId}`;
      const res = await guacHttpClient.patch<CallResponse, HttpResponse<CallResponse>, UpdateCallRequest>(path, updateCallRequest);
      return res.data;
    },
  });
}
